<template>
  <el-container class="patroladd">
     
    <el-header class="box add bb">
         <el-breadcrumb separator-class="el-icon-arrow-right">
       <el-breadcrumb-item>自查自纠</el-breadcrumb-item>
       <el-breadcrumb-item >自查自纠列表</el-breadcrumb-item>
         <el-breadcrumb-item >新增自查自纠</el-breadcrumb-item>
    </el-breadcrumb>

        <div><el-button  class="back_btn" size="medium" plain @click="$router.back()">返回</el-button></div>
    </el-header>
    <el-main class="">
    <el-form  :inline="true"  status-icon ref="form"  :model="form"  class="demo-ruleForm">
      <el-row>
         <el-col :span="11" class="tl" >
           <el-form-item label="经营者姓名："  class="w" label-width="28%"  prop='operator'  :rules="[{required: true,message: '请输入经营者姓名', trigger: 'blur' },{ pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }]">
          <el-input v-model="form.operator" size="medium"  clearable></el-input>
        </el-form-item>
        </el-col>
      </el-row>
         <el-table border :data="menu_list" style="width: 100%">
      
        <el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
       <el-table-column prop="attr_ch" min-width="150" :show-overflow-tooltip="true"  label="名称" align='center'></el-table-column>
        <el-table-column min-width="150" :show-overflow-tooltip="true"  label="备注" align='center'>
          <template slot-scope="scope">
            <el-form-item size="small" >
              <el-input placeholder="请输入备注" clearable  v-model="scope.row.attr_note"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
         <el-table-column label="图片上传" width="250"   align='center'>
          <template slot-scope="scope">
            <el-upload  class="health_url"
                ref="upload"
                v-if="imageUrl=='1234567'"
                fit="fill" style="width: 70px;height: 40px"
                action="/pc/file/upload"
                 accept="image/png,image/jpg,image/jpeg"
                 :multiple='false'
                 :limit="1"
                  list-type="picture-card"
                :on-success="(res,file) =>{return handlepoll11(res,file,scope.$index)}"
                :on-preview="handlePictureCardPreview"
                :on-remove="(file) =>{return handleRemove11(file,scope.$index)}"
                :before-remove="(file) =>{return beforeRemove(file,scope.$index)}"
                :class="{disabled:scope.row.uploadDisabled1}"
                >
               <el-button size="medium" type="primary" >点击上传</el-button>
            </el-upload>
            <el-upload  class="health_url"
                ref="upload"
                v-else
                fit="fill" style="width: 70px;height: 40px"
                action=""
                 accept="image/png,image/jpg,image/jpeg"
                 :multiple='false'
                 :limit="1"
                  list-type="picture-card"
                :http-request="(params) =>{return handlepoll(params)}"
                :on-preview="handlePictureCardPreview"
                :on-remove="(file) =>{return handleRemove11(file,scope.$index)}"
                :before-remove="(file) =>{return beforeRemove(file,scope.$index)}"
                :class="{disabled:scope.row.uploadDisabled1}"
                >
               <el-button size="medium" type="primary" >点击上传</el-button>
            </el-upload>
          </template>
        </el-table-column>
          <el-table-column label="是否合格" fixed="right" width="200px" align="center">
            <template slot-scope="scope">
              <el-switch active-text="合格"
  inactive-text="不合格" v-model="scope.row.status" active-color="#409EFF" inactive-color="#ccc" @change="changeStatus(scope.row,scope.$index)"> </el-switch>
            </template>
          </el-table-column>
      </el-table>
    
      <div class="i-page fr disib mt20">
        <el-pagination
          background
          :page-size='10'
          layout="total,prev, pager, next"
          :total="total"
          :current-page="currentPage"
         @current-change = 'currentChange'>
        </el-pagination>
      </div>
      <div class="tl mt15">
             <el-button  class=""  size="medium" type="primary" @click="submitForm('form')">提交</el-button>
          </div>
     </el-form>
     </el-main>
  </el-container>
</template>
<script>
import axios from '../../../util/api'
import { local,session } from '../../../util/util'
import {imageUrl} from '../../../config/index'
import { tengxuncloud } from '@/util/aliOss'
export default {
  data () {
    return {
      menu_list:[],
      imageUrl:imageUrl,
      uploadDisabled11: false,
       dialogImageUrl: '',
        dialogVisible: false,
      activeNames: ['1'],
        form: {
          check_self_id:'',
            operator:'',
          content:[]
      },
        user_id_add:'',
        user_name_add:'',
          currentPage: 1,
      total: 0,
      curRowIndex: null,
    }
  },
     created () {
      this.user = local.get('user');
       this.user_id_add=this.user.user_id;
        this.form.operator=this.user.user_name;
       this.form.check_self_id=session.get('params').id?String(session.get('params').id):'';
     this.init()
  },
  methods: {
     init (params) {
  
         axios.get('/pc/company-cs/config').then((v) => {
         
             this.menu_list= JSON.parse(JSON.parse(v.data.page_config)).map(item => {
                return {...item, uploadDisabled1: false,status: false}
              })
      }) 

    },
    // 分页
    currentChange(page){
        var that=this;
      that.currentPage = page;
      that.page.pager_offset = String((page - 1) * 10)
      that.init()
    },
     handleRemove11(file, index) {
        this.menu_list[index].uploadDisabled1 = false;
          this.menu_list[index].attr_img=''
      },
      handlepoll11 (response, file,index) {
         this.menu_list[index].uploadDisabled1 = true;
         if(this.imageUrl=='1234567'){
        this.menu_list[index].attr_img=response.data.visit_url
      }else{
        tengxuncloud(response).then((res) => {
         this.menu_list[index].attr_img= res.url
       })
      }
          
    },
      beforeRemove(file, index){
      if (file && file.status==="success") {
         return this.$confirm(`确定移除吗？`);
      }
    },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
          changeStatus(row,index){ 
			// row.status = true
	},
     submitForm(form){
       this.form.content=[]
     
       this.menu_list.forEach(item=>{
         this.form.content.push({
           attr_ch:item.attr_ch,
           attr_note:item.attr_note,
           attr_img:item.attr_img,
           attr_val:item.status===false?'不合格':'合格'
         })
       })
      this.form.content=JSON.stringify(this.form.content)
         this.$refs[form].validate((valid) => {
        if (valid) {
  
             axios.post('/pc/company-cs/save', this.form).then((v) => {
      this.$router.back()
      })
          }else{
           this.$message.error('请检查表单必填项');
            return false
        }
         })
      },
      handleChange(){}
  }
}
</script>
<style lang="scss" scoped>
.patroladd{
   overflow-x: hidden;
  .add{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .el-image{width: 160px; height: 160px;margin-right: 10px}
  .back_btn{background:rgba(247,248,249,1);border:1px solid rgba(217,222,225,1);}
  .patroladd-title{height: 34px;line-height: 34px;border-left: 2px solid #788287}
  .patroladd-title1{height: 34px;line-height: 34px;}
.el-checkbox{    display: flex;
    justify-content: left;
    align-items: center;}
/deep/ .el-collapse-item .el-collapse-item__content{padding-bottom: 0px;}
    /deep/ .el-upload-list--picture-card .el-upload-list__item{width: 160px;height: 160px;}
   }
    .health_url{
          margin-left: 80px;
     /deep/ .el-upload--picture-card{width: 70px;height: 40px;
     background-color: transparent;
    border: none;
     .el-button--medium{position: absolute;left: 32%;;margin-top: 4px;}}

/deep/ .el-upload-list--picture-card .el-upload-list__item{width: 70px;height: 40px;}

   } 
        /deep/ .disabled .el-upload--picture-card {
    display: none !important;
}

</style>
